import { makeStyles } from '@mui/styles';
import Checkbox from 'apollo-react/components/Checkbox';
import classNames from 'classnames';
import React from 'react';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    paddingLeft: 10,
    paddingTop: 10,
    textAlign: 'center',
  },
  selected: {
    '& svg': {
      fill: 'white !important',
    },
    '& [class*="MuiCheckbox-root"] svg path:nth-of-type(2)': {
      fill: '#0768fd !important',
    },
  },
});

const CheckBoxCell = ({ row, column: { accessor: key } }) => {
  const classes = useStyles();

  const handleOnClick = () => {
    row.handleSelectRow && row.handleSelectRow({ rowId: row.rowId });
  };

  return (
    <div className={classNames(classes.actions, row.isSelected && classes.selected)}>
      <Checkbox
        checked={row[key]}
        onClick={handleOnClick}
        onChange={({ target: { checked } }) =>
          row.editRow({
            rowId: row.rowId,
            key,
            value: checked,
          })
        }
        aria-label={row[key]}
      />
    </div>
  );
};

export default CheckBoxCell;
